<template>
    <div class="page-pay">
        <div class="table common-wrap">
            <div class="tit"><!--共 5 笔-->订单</div>
            <div class="table-f">
                <el-table
                        :data="tableData"
                        stripe
                >
                    <el-table-column
                            prop="courseName"
                            label="名称"
                            min-width="200"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="tradePayNo"
                            label="交易号"
                            align="center"
                            min-width="150"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="creatorName"
                            label="作者"
                            align="center"
                            min-width="150"
                    >
                    </el-table-column>
                    <el-table-column
                            label="金额"
                            align="center"
                            min-width="100"
                            fixed="right"
                    >
                        <template slot-scope="scope">
                            <span class="price-style" >￥{{order.paymentAmount}}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <div class="pay-wrap common-wrap">
            <div class="top-wrap com-pad">
                <div class="tit">请选择支付方式：</div>
                <ul class="pay-type clearfix">

                    <li @click="selectPayType(1)" :class="{'active': payTypeNum === 1}"><img
                            :src="require('@/assets/images/pay_wechat.jpg')" alt=""></li>
                    <li @click="selectPayType(0)" :class="{'active': payTypeNum === 0}"><img
                            :src="require('@/assets/images/pay_ali.jpg')" alt=""></li>
                </ul>
            </div>
            <div class="bot-wrap com-pad">
                <div >
                    <div class="price">商品金额：￥{{order.paymentAmount}}</div>
                    <div class="total">合计：<span>￥{{order.paymentAmount}}</span></div>
                    <el-button @click="toPay" type="danger">确认付款</el-button>
                </div>

            </div>
        </div>
        <el-dialog
                title="付款"
                :visible.sync="dialogVisible"
                :close-on-click-modal="false"
                :before-close="handleClose"
                width="300px"
        >
            <div class="qr-code" id="qrcodeImgEl">
            </div>
            <span slot="footer" class="dialog-footer">
<!--        <el-button type="primary">已完成</el-button>-->
      </span>
        </el-dialog>
    </div>
</template>

<script type="text/ecmascript-6">
    import courseApi from '@/api/courseDh'
    import axios from 'axios';
    import vue from 'vue';

    vue.prototype.$axios = axios;
    export default {
        components: {},
        data() {
            return {
                orderId:'',
                orderType:2, //2点播课，５直播
                payTypeNum: 1,
                dialogVisible: false,
                tableData: [],
                course: {},
                WeiXin: '',
                ZhiFuBao: '',
                id: 0,
                pId:0,
                timer: '',
                order:{},
              orderDetail:{},
            }
        },
        mounted() {
            let id = this.$route.query.id

            let orderType = this.$route.query.orderType
            this.id = id
            this.pId= this.$route.query.pId
            this.orderType = orderType

            this.getQRCode(id,1);

        },
        beforeDestroy() {
            clearInterval(this.timer);
        },
        methods: {
            selectPayType(num) {
                this.payTypeNum = num
              if (this.payTypeNum == 0&&this.ZhiFuBao == '') {
                this.getQRCode(this.id,2)
              }
              if (this.payTypeNum == 1&&this.WeiXin == '') {
                this.getQRCode(this.id,1)
              }
            },
            toPay() {
                let _this = this
                _this.dialogVisible = true
                _this.$nextTick(() => {
                    const qrcodeImgEl = document.getElementById('qrcodeImgEl')
                    qrcodeImgEl.innerHTML = ''
                    let qrcode = new _this.QRCode(qrcodeImgEl, {
                        width: 150,
                        height: 150,
                        colorDark: '#000000',
                        colorLight: '#ffffff',
                        correctLevel: _this.QRCode.CorrectLevel.H
                    })
                    if (_this.payTypeNum == 0) {
                        qrcode.makeCode(_this.ZhiFuBao.credential);
                    } else {
                        qrcode.makeCode(_this.WeiXin.credential);
                    }

                    //查询订单是否支付完成
                    _this.timer = setInterval(_this.ifPayed, 2000);
                })

            },
            handleClose(done) {
                clearInterval(this.timer);
                done()
            },
            ifPayed() {
                let _this = this;
                console.log(_this.course.classificationOf)
                if (_this.global.isLogin) {
                    let url = '/rrbi/pay/ifPayed?productId=' + _this.id + '&orderType=' + _this.orderType + '&time=' + new Date().getMilliseconds();
                    _this.$axios.get(url).then(function (result) {
                        if (result.data == 1) {
                            clearInterval(_this.timer);
                            _this.$message.success("支付成功")
                            //返回详情
                            if(_this.course.classificationOf == 13){
                                //生成一个订单，检查报名使用　--点播
                                let signUpUrl='/rrbi/coursefront/signUp?courseId='+_this.id+'&userId='+_this.global.userModel.id+ '&time='+new Date().getMilliseconds();
                                // console.log(signUpUrl)
                                if(_this.course.courseSeries == 0){
                                    _this.$axios.get(signUpUrl).then(function(signResult){
                                        _this.$router.push({
                                            path: '/videodetail',
                                            query: {
                                                id: _this.pId,
                                                plate:_this.course.belongSection
                                            }
                                        })
                                    })
                                }else{
                                    _this.$axios.get(signUpUrl).then(function(signResult){
                                        _this.$router.push({
                                            path: '/videoduo',
                                            query: {
                                                id: _this.pId,
                                                plate:_this.course.belongSection
                                            }
                                        })
                                    })
                                }


                            }else{
                                //生成一个订单，检查报名使用  --直播
                                let signUpUrl='/rrbi/livefront/signUp?courseId='+_this.id+'&userId='+_this.global.userModel.id+ '&time='+new Date().getMilliseconds();
                                // console.log(signUpUrl)
                                _this.$axios.get(signUpUrl).then(function(signResult){
                                    _this.$router.push({
                                        path: '/livedetail',
                                        query: {
                                            id: _this.course.liveId,
                                            plate:_this.course.belongSection
                                        }
                                    })
                                })

                            }

                        }
                    })
                }
            },
            getCourse(id) {
                let _this = this

                courseApi.select(id).then(data => {
                    if (data.code == 1) {
                        _this.course = data.response
                        _this.course.tradePayNo = _this.WeiXin.tradePayNo

                      if(_this.tableData.length==0){
                        _this.tableData.push(_this.course)
                      }
                        _this.ifPayed()
                    } else if (data.code == -1) {
                        _this.$message.error("参数错误")
                    } else if (data.code == -2) {
                        _this.$message.error("无权限访问")
                    } else if (data.code == -3) {
                        _this.$message.error("课程已删除")
                    }
                })
            },
            getQRCode(id,paymentChannel) {
                var _this = this;
                // console.log("id===",id)
                // console.log("_this.orderType===",_this.orderType)
                let url = '/rrbi/pay/getQRCode?payType=0&productId=' + id + '&paymentChannel='+paymentChannel+'&orderId='+_this.orderId+'&orderType=' + _this.orderType + '&time=' + new Date().getMilliseconds();
                console.log(url)
                _this.$axios.get(url).then(function (result) {
                  console.log(result)
                    if (result.data.code == 1) {
                      if(paymentChannel ==1){
                        _this.WeiXin = result.data.WeiXin
                      }else if(paymentChannel==2){
                        _this.ZhiFuBao = result.data.ZhiFuBao
                      }else {
                        _this.WeiXin = result.data.WeiXin
                        _this.ZhiFuBao = result.data.ZhiFuBao
                      }
                        if(_this.orderId === ''){
                          _this.orderId = result.data.order.id
                          _this.order = result.data.order
                          _this.orderDetail = result.data.orderDetail
                        }


                        _this.getCourse(_this.orderDetail.productId)
                    } else {
                        _this.$message.error(result.data.message)
                    }
                })
            }
        }
    }
</script>

<style scoped lang="less">
   // @import "../../../assets/less/stylePublic.less";

    .page-pay {
        padding-top: @NAVHEIGHT;
        padding-bottom: 30px;

        .table {
            padding-bottom: 30px;
            margin: 30px auto 10px;
            background: #fff;

            .tit {
                padding: 30px 50px 10px;
                color: #000;
                font-size: 18px;
                border-bottom: 2px solid #f6f6f6;
            }

            .table-f {
                margin: 0 50px;

                /deep/ .el-table--striped .el-table__body tr.el-table__row--striped td {
                    background: #f7faff;
                }
            }

            .price-style {
                color: @HEADBG;
            }
        }

        .pay-wrap {
            background: #fff;

            .com-pad {
                padding: 25px 50px;
            }

            .top-wrap {
                .tit {
                    color: #000;
                    font-size: 18px;
                    line-height: 24px;
                }

                .pay-type {
                    margin-top: 20px;

                    li {
                        padding: 10px;
                        margin-right: 30px;
                        float: left;
                        width: 200px;
                        height: 70px;
                        cursor: pointer;

                        img {
                            width: 100%;
                            height: 100%;
                        }

                        &.active {
                            position: relative;

                            &:after {
                                position: absolute;
                                left: 0;
                                top: 0;
                                content: '';
                                display: block;
                                width: 100%;
                                height: 100%;
                                border: 2px solid @HEADBG;
                            }
                        }
                    }
                }
            }

            .bot-wrap {
                border-top: 1px solid #f6f6f6;

                .price {
                    color: #676767;
                    font-size: 14px;
                }

                .total {
                    margin-top: 5px;
                    margin-bottom: 20px;
                    color: #2f3032;
                    font-size: 22px;

                    span {
                        color: @HEADBG;
                    }
                }
            }
        }

        .qr-code {
            margin: 0 auto;
            width: 150px;
            height: 150px;
            background: pink;
        }
    }

    @media screen and (max-width: 900px) {
        .page-pay {
            .table {
                margin: 0;

                .tit {
                    padding: 10px;
                }

                .table-f {
                    margin: 0 10px;
                }
            }

            .pay-wrap {
                .com-pad {
                    padding: 10px;
                }

                .top-wrap {
                    .pay-type {
                        margin-top: 10px;

                        li {
                            margin-right: 10px;
                            width: 150px;
                            height: 55px;
                        }
                    }
                }
            }
        }
    }
</style>
